/* /cart shipping/billing address sections: collapsible accordions.
 *
 * Core webshop's cart_address.html (no-touch-core) renders both sections
 * permanently expanded, full address detail always showing. Once an address
 * is already selected that's a lot of vertical space (worse on mobile) for
 * information the shopper usually doesn't need to re-check - this adds a
 * toggle to each section's existing header row without editing core markup.
 *
 * A toggle <button>, not the whole header row: the header also carries core's
 * own "Add a new address" link, and keeping the toggle as the sole click
 * target avoids having to exclude that link from a row-wide click handler.
 */
(function () {
	'use strict';

	function setCollapsed(section, toggle, collapsed) {
		section.classList.toggle('rfhq-address-collapsed', collapsed);
		toggle.setAttribute('aria-expanded', String(!collapsed));
	}

	function enhance(section) {
		if (section.dataset.rfhqAddressEnhanced) return;
		section.dataset.rfhqAddressEnhanced = '1';

		var header = section.querySelector('.d-flex');
		var actionsCol = header && header.querySelector('.col-6:last-child');
		if (!header || !actionsCol) return;

		var toggle = document.createElement('button');
		toggle.type = 'button';
		toggle.className = 'rfhq-address-toggle';
		toggle.setAttribute('aria-label', __('Toggle address details'));
		toggle.innerHTML =
			'<svg viewBox="0 0 24 24" aria-hidden="true" class="rfhq-address-toggle__icon">' +
			'<path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>' +
			'</svg>';
		actionsCol.appendChild(toggle);
		header.classList.add('rfhq-address-header');

		// Collapsed by default once an address is already active (returning
		// cart); left expanded when nothing is selected yet, so a first-time
		// shopper isn't hiding the one thing they still need to do.
		var hasActiveAddress = Boolean(section.querySelector('.address-container[data-active]'));
		setCollapsed(section, toggle, hasActiveAddress);

		toggle.addEventListener('click', function () {
			setCollapsed(section, toggle, !section.classList.contains('rfhq-address-collapsed'));
		});
	}

	frappe.ready(function () {
		if (!document.querySelector('.cart-container')) return; // not this page
		document
			.querySelectorAll('[data-section="shipping-address"], [data-section="billing-address"]')
			.forEach(enhance);
	});
}());
